import {useMutation} from 'react-query'

import {mutations} from '../../mutations'
import {hubQueryClient} from '../../QueryProvider'

export const usePostOrderRequestDelivery = () => {
  return useMutation(mutations.postOrderRequestDelivery, {
    onMutate: async () => {
      await hubQueryClient.invalidateQueries('orderRequests')
    }
  })
}
